import React, { useState } from 'react';
import { Home } from './Home';
import { About } from './About';
import { SpeedInsights } from '@vercel/speed-insights/react';

import { ReactComponent as Logo } from './assets/icon.svg'; // Assuming the file is SVG


const pages = {
  home: Home,
  about: About,
};

export default function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [theme] = useState('light');

  const PageComponent = pages[currentPage];

  const handleNavigation = (page) => {
    if (page === 'contact') {
      window.location.href = 'https://www.facebook.com/profile.php?id=61566806399018';
    } else {
      setCurrentPage(page);
    }
  };

  return (
    <div className={`app flex flex-col min-h-screen ${theme}`} data-theme={theme}>
      <div className="drawer flex-grow">
        <input id="my-drawer-3" type="checkbox" className="drawer-toggle" /> 
        <div className="drawer-content flex flex-col">
          <div className="w-full navbar bg-base-300">
            <div className="flex-none lg:hidden">
              <label htmlFor="my-drawer-3" className="btn btn-square btn-ghost">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" className="inline-block w-6 h-6 stroke-current">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                </svg>
              </label>
            </div> 
            <div className="flex-1 px-2 mx-2">
              <button onClick={() => handleNavigation('home')} className="text-2xl font-bold">
                GS
              </button>
            </div>
            <div className="flex-none hidden lg:block">
              <ul className="menu menu-horizontal">
                {[...Object.keys(pages), 'contact'].map((page) => (
                  <li key={page}>
                    <button
                      onClick={() => handleNavigation(page)}
                      className={`capitalize ${currentPage === page ? 'active' : ''}`}
                    >
                      {page}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <main className="flex-grow container mx-auto p-4">
            <PageComponent />
          </main>
        </div> 
        <div className="drawer-side">
          <label htmlFor="my-drawer-3" className="drawer-overlay"></label> 
          <ul className="menu p-4 w-80 bg-base-100">
            {[...Object.keys(pages), 'contact'].map((page) => (
              <li key={page}>
                <button
                  onClick={() => {
                    handleNavigation(page);
                    document.getElementById('my-drawer-3').checked = false;
                  }}
                  className={`capitalize ${currentPage === page ? 'active' : ''}`}
                >
                  {page}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      
      <footer className="footer bg-neutral text-neutral-content items-center p-4">
  <aside className="grid-flow-col items-center">
  <Logo className="w-10 h-10 mx-auto" />
    <p>© {new Date().getFullYear()} - GS PC Parts and Builds</p>
  </aside>
</footer>
<SpeedInsights />
    </div>
  );
}
